import { PAGE_KEYS } from "./pageKeys";

/**
 * Next.js pathname / asPath → page_key
 * 未登记路由返回 null（不上报 page_view）
 */
const ROUTE_RULES = [
  { test: (p) => p === "/" || p === "/index", pageKey: PAGE_KEYS.HOME },
  { test: (p) => /^\/futures(\/|$)/.test(p) || /^\/cfd(\/|$)/.test(p), pageKey: PAGE_KEYS.CFD_TRADE },
  { test: (p) => /^\/aicopy\/[^/]+/.test(p), pageKey: PAGE_KEYS.AICOPY_SIGNAL },
  { test: (p) => /^\/aicopy(\/|$)/.test(p), pageKey: PAGE_KEYS.AICOPY_LIST },
  { test: (p) => /^\/activity\/voucher/.test(p), pageKey: PAGE_KEYS.COUPON_CENTER },
  { test: (p) => /^\/verify(\/|$)/.test(p), pageKey: PAGE_KEYS.KYC_MAIN },
  { test: (p) => /^\/market(\/|$)/.test(p), pageKey: PAGE_KEYS.HOME },
  { test: (p) => /^\/credit(\/|$)/.test(p), pageKey: PAGE_KEYS.DEPOSIT_FIAT },
  { test: (p) => /luckywheel|spin/i.test(p), pageKey: PAGE_KEYS.SPIN_MAIN },
];

function normalizePath(path) {
  if (!path) return "";
  const withoutQuery = String(path).split("?")[0].split("#")[0];
  const stripped = withoutQuery.replace(/^\/[a-z]{2}(-[A-Z]{2})?(?=\/|$)/i, "");
  return stripped || "/";
}

export function resolvePageKeyFromPath(path) {
  const normalized = normalizePath(path);
  for (const rule of ROUTE_RULES) {
    if (rule.test(normalized)) return rule.pageKey;
  }
  return null;
}

export default resolvePageKeyFromPath;
